// extracted by mini-css-extract-plugin
module.exports = {"wrap":"AdminSettingsEmailsContainer_wrap__8nq5g","btns":"AdminSettingsEmailsContainer_btns__2ea0F","editorWrapper":"AdminSettingsEmailsContainer_editorWrapper__1eLn3"};